import {
  Button,
  Divider,
  Grid,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { EventBusyOutlined, Search, Tune } from "@material-ui/icons";
import { ptBR } from "date-fns/locale";
import { memo, useEffect } from "react";
import { DateRangePicker, END_DATE, START_DATE } from "react-nice-dates";
import "react-nice-dates/build/style.css";
import SelectErp from "../../../../components/basics/SelectErp";
import Card from "../../../../components/cards/Card";
import { periods } from "../../../financeiro/constants";
import {
  invoiceMirrorContractModality,
  invoiceMirrorContractStatus,
  invoiceMirrorDateType,
} from "../constants";
import { useEspelhoFaturamentoService } from "../context/EspelhoFaturamentoContext";
import { ClearButton } from "../styles";
import "../styles/style.css";
import GroupMenuButton from "./GroupButton";
import SelectFilter from "./SelectFilter";
import SituationChip from "./SituationChip";
import SituationsDrawer from "./SituationsDrawer";

const Filter = () => {
  const {
    refetch,
    filters,
    cachedCompanies,
    cachedClients,
    setSelectedCompany,
    setSelectedCustomer,
    isCompanyLoading,
    isClientLoading,
    setPeriod,
    filterPeriod,
    setCustomDatePeriod,
    setContractStatus,
    setContractNumber,
    setModality,
    setDateFilter,
    setDrawerOpen,
    cachedSituations,
    quickSituations,
  } = useEspelhoFaturamentoService();

  useEffect(() => {
    (async () => {
      setTimeout(refetch, 1);
    })();
  }, [filters.multipleSort, refetch]);

  const checkedSituations = [
    ...cachedSituations.filter((situation) =>
      filters.accountReceivableStatus?.includes(situation.id)
    ),
    ...quickSituations.filter((situation) =>
      filters.accountReceivableQuickStatus?.includes(situation.id)
    ),
  ];

  return (
    <Grid item xs>
      <Grid
        item
        container
        component={Card}
        direction={"column"}
        style={{
          gap: 24,
          borderLeft: "6px solid #d6e5ff",
          boxSizing: "border-box",
        }}
      >
        <SituationsDrawer />

        <Grid item container xs style={{ gap: 16 }}>
          <Grid item xs>
            <SelectFilter
              filterMatch={filters.multicompany}
              filterOptions={cachedCompanies}
              setFilter={setSelectedCompany}
              label="Empresa"
              loading={isCompanyLoading}
            />
          </Grid>

          <Grid item xs>
            <SelectErp
              label={"Cliente"}
              loading={isClientLoading}
              lg={2}
              onChange={(option) => {
                setSelectedCustomer(option?.value);
              }}
              InputLabelProps={{ shrink: true }}
              placeholder="Busque pela Razão Social do cliente"
              optionsList={cachedClients}
              descriptionField="description"
            />
          </Grid>

          <Grid item xs>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Nº Contrato"
              placeholder="Busque por número de Contrato"
              onChange={(event) => setContractNumber(event.target.value)}
            />
          </Grid>

          <Grid item xs>
            <SelectFilter
              label="Status Contrato"
              filterMatch={filters.contractStatus}
              filterOptions={invoiceMirrorContractStatus}
              setFilter={setContractStatus}
            />
          </Grid>
          <Grid item xs>
            <SelectFilter
              label="Modalidade Contrato"
              filterMatch={filters.contractModality}
              filterOptions={invoiceMirrorContractModality}
              setFilter={setModality}
            />
          </Grid>
        </Grid>
        <Grid item container xs style={{ gap: 8 }}>
          <Grid item xs={2}>
            <SelectFilter
              label="Data de:"
              filterMatch={filters.dateFilter}
              filterOptions={invoiceMirrorDateType}
              setFilter={setDateFilter}
            />
          </Grid>

          <Grid item xs={2}>
            <SelectFilter
              label="Periodo de busca"
              filterMatch={filters.period}
              filterOptions={periods}
              setFilter={setPeriod}
            />
          </Grid>
          {filters.period === periods.Personalizado && (
            <Grid item xs={4}>
              <DateRangePicker
                startDate={filterPeriod.startDate}
                endDate={filterPeriod.endDate}
                onStartDateChange={(newDate) => {
                  setCustomDatePeriod({
                    startDate: newDate,
                  });
                }}
                onEndDateChange={(newDate) => {
                  setCustomDatePeriod({
                    endDate: newDate,
                  });
                }}
                minimumLength={0}
                format="dd/MM/yyyy"
                weekdayFormat="EEEEE"
                locale={ptBR}
                maximumLength={365}
              >
                {({ startDateInputProps, endDateInputProps, focus }) => (
                  <div
                    className="date-range"
                    style={{
                      display: "flex",
                      gap: 16,
                    }}
                  >
                    <TextField
                      size="small"
                      label="Data inicial"
                      className={
                        "input" + (focus === START_DATE ? " -focused" : "")
                      }
                      {...startDateInputProps}
                      placeholder="Ex: 01/12/2022"
                    />
                    <TextField
                      size="small"
                      label="Data final"
                      className={
                        "input" + (focus === END_DATE ? " -focused" : "")
                      }
                      {...endDateInputProps}
                      placeholder="Ex: 31/12/2022"
                    />
                    <Tooltip title="Limpar filtro de datas">
                      <ClearButton
                        size="small"
                        onClick={() =>
                          setCustomDatePeriod({
                            startDate: undefined,
                            endDate: undefined,
                          })
                        }
                      >
                        <EventBusyOutlined />
                      </ClearButton>
                    </Tooltip>
                  </div>
                )}
              </DateRangePicker>
            </Grid>
          )}
          <Grid item xs />
        </Grid>
        {!!checkedSituations.length && (
          <Grid
            item
            xs
            style={{
              alignItems: "center",
              display: "flex",
              flexWrap: "wrap",
              gap: 8,
            }}
          >
            <Typography style={{ fontWeight: "bold" }} variant="subtitle2">
              Situações:
            </Typography>
            {checkedSituations.map((item) => {
              return <SituationChip situation={item} key={item.id} />;
            })}
          </Grid>
        )}

        <Divider />
        <Grid item xs container direction="row" spacing={2}>
          <Grid item xs>
            <Button
              size="small"
              color="primary"
              variant="contained"
              startIcon={<Search />}
              onClick={async () => {
                await refetch();
              }}
            >
              Gerar relatório
            </Button>
          </Grid>
          <Grid item>
            <GroupMenuButton label={"Agrupando"} />
          </Grid>
          <Grid item>
            <Button
              startIcon={<Tune />}
              color="primary"
              variant="outlined"
              size="small"
              onClick={() => setDrawerOpen(true)}
            >
              Situação Financeiro
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default memo(Filter);
